import React, { useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";

const SuccessPage = () => {
  const [showTick, setShowTick] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setShowTick((prev) => !prev); // Toggle the state to make the tick blink
    }, 800);

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const successPageStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#4CAF50", // Green color
    color: "white",
    marginTop: "-5vh",
  };

  const tickStyle = {
    fontSize: "3em",
    opacity: showTick ? 1 : 0,
    transition: "opacity 0.5s ease-in-out",
  };

  return (
    <div style={successPageStyle}>
      <div style={tickStyle}>
        <FaCheckCircle />
      </div>
      <h2>Registration Successful!</h2>
      {/* Add additional content or styling as needed */}
    </div>
  );
};

export default SuccessPage;
